export default __webpack_public_path__ + "firstFooter.29c476e.png";